import React from 'react';

const ReportFooter = () => {
  const styles = {
    footer: {
      marginTop: 'auto', // Pushes footer to the bottom of the flex container
      paddingTop: '24px',
      borderTop: '1px solid #e2e8f0',
      textAlign: 'center',
      fontSize: '12px',
      color: '#718096',
    },
    text: {
        lineHeight: 1.5,
    }
  };

  return (
    <div style={styles.footer}>
      <p style={styles.text}>
        Generated by Inara GRWM. This report is for informational purposes only and does not constitute medical advice.
        <br />
        For personal use. Do not redistribute without permission.
      </p>
    </div>
  );
};

export default ReportFooter;
